import React from 'react';
import ReactGA from 'react-ga4';
import { useNavigate } from 'react-router-dom';

import LovebirdOrgLogo from '../../assets/images/image/lovebird_org_logo.svg';
import Button from '../../components/v2/Button/Button';
import { Modal } from '../../components/v2/Modal/Modal';
import { Typography } from '../../components/v2/Typography/Typography';
import { ORDINATION_ORG_NAME } from '../../constants/brand';
import { useDashboard } from '../../provider/dashboardProvider';

const OrdainedInfoModal = () => {
  const {
    ordainedInfoModalOpen,
    setOrdainedInfoModalOpen,
    setOrdainedApplicationModalOpen,
    ceremony,
  } = useDashboard();

  const navigate = useNavigate();

  const handleContinue = () => {
    ReactGA.event({
      category: 'Ordination',
      action: 'Ordination Started',
      label: 'Ordination Started',
    });

    setOrdainedInfoModalOpen(false);
    setOrdainedApplicationModalOpen(true);
  };

  const handleRedirectToRegularPaywall = () => {
    ReactGA.event({
      category: 'Ordination',
      action: 'Redirect to Regular Paywall',
      label: 'Redirect to Regular Paywall',
    });

    const ceremonyId = ceremony?.id;

    setOrdainedInfoModalOpen(false);

    ceremonyId &&
      navigate(`/pay-plans/${ceremonyId}?refferedFrom=ordained-info-modal`);
  };

  return (
    <Modal
      isOpen={ordainedInfoModalOpen}
      onClose={() => setOrdainedInfoModalOpen(false)}
      showCloseButton={true}
      title={''}
    >
      <div className='max-w-[500px] flex flex-col justify-center items-center'>
        {/*
          Sized by WIDTH, not height. This is a ~5.7:1 wordmark where the old PCO
          mark was a square roundel, so the previous `h-28` would compute to
          roughly 640px across and burst the modal's `max-w-[500px]`.
        */}
        <img
          src={LovebirdOrgLogo}
          alt={`${ORDINATION_ORG_NAME} Logo`}
          className='w-[240px] h-auto mt-2'
        />
        <Typography
          type='display-100'
          className='text-center max-w-[436px] mt-6'
        >
          Get legally ordained in 1 minute!
        </Typography>
        <Typography type='body-400' className='text-center mt-4 max-w-[436px]'>
          Once complete, you’ll be able to confidently officiate weddings across
          the United States.
        </Typography>
        <div className='border border-forest-primary rounded-3xl mt-8 p-6'>
          <Typography variant='functional-high' type='body-400'>
            Things to note before you begin
          </Typography>
          <ul className='pl-4 max-w-[436px]'>
            <li className='list-disc pt-4'>
              <Typography variant='functional-low' type='body-400'>
                <>
                  Instant, free, online ordination made possible by{' '}
                  {ORDINATION_ORG_NAME}
                </>
              </Typography>
            </li>
            <li className='list-disc pt-4'>
              <Typography variant='functional-low' type='body-400'>
                After finishing, you can order your official certificate and
                other resources.
              </Typography>
            </li>
          </ul>
        </div>
        <div className='flex flex-row gap-4 justify-between w-full'>
          <Button
            variant='text'
            className='mt-8'
            onClick={() => handleRedirectToRegularPaywall()}
          >
            Unlock without getting ordained
          </Button>
          <Button className='mt-8' onClick={handleContinue}>
            Continue
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default OrdainedInfoModal;
